import { selectSelectedCompanyOrgId, useAppSelector } from '@ibk/shared-config';
import { locationApi } from '../services/locationApi';
export function useCompanyAddress() {
    const selectedCompanyOrgId = useAppSelector(selectSelectedCompanyOrgId);
    const { data, isLoading, isError, error: queryError, refetch, isFetching, } = locationApi.endpoints.getLocationsByOrganization.useQuery({
        organizationId: selectedCompanyOrgId ?? '',
    }, {
        skip: !selectedCompanyOrgId,
    });
    const [createLocation, { isLoading: isCreating }] = locationApi.useCreateLocationMutation();
    const [updateLocation, { isLoading: isUpdating }] = locationApi.useUpdateLocationMutation();
    const currentLocation = data?.result?.[0] ?? null;
    const allLocations = data?.result ?? [];
    const getErrorMessage = () => {
        if (!isError || !queryError) {
            return null;
        }
        if ('data' in queryError) {
            const errorData = queryError.data;
            return errorData?.message ?? 'Erro ao carregar endereço';
        }
        return 'Erro de conexão';
    };
    const errorMessage = getErrorMessage();
    const saveLocation = async (location) => {
        if (!selectedCompanyOrgId) {
            throw new Error('Nenhuma empresa selecionada');
        }
        if (currentLocation?.locationId) {
            await updateLocation({
                organizationId: selectedCompanyOrgId,
                locationId: currentLocation.locationId,
                location,
            });
        }
        else {
            await createLocation({
                organizationId: selectedCompanyOrgId,
                location,
            });
        }
        await refetch();
    };
    return {
        currentLocation,
        allLocations,
        isLoading,
        isSaving: isCreating || isUpdating,
        isRefetching: isFetching && !isLoading,
        isError,
        error: errorMessage,
        refetch: async () => {
            await refetch();
        },
        saveLocation,
    };
}
